export interface IEnkRadioButtonProps {
  label: string
  id: string
  group: string
  disabled?: boolean
  description?: string
  onClick?: () => void // Added onClick prop
}

export function EnkRadioButton(props: IEnkRadioButtonProps) {
  const { label, group, id, disabled, description, onClick } = props
  return (
    <div className="relative flex gap-x-3">
      <div className="flex h-6 items-center">
        <input
          id={id}
          name={group}
          type="radio"
          disabled={disabled}
          onClick={onClick} // Pass onClick to the input
          className={`h-4 w-4 border-gray-300 text-primary focus:ring-primary ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
        />
      </div>
      <div className="text-sm leading-6">
        <label htmlFor={id} className={`block text-sm font-medium leading-6 ${disabled ? "text-gray-400" : "text-gray-900"}`}>
          {label}
        </label>
        <p className="text-gray-500">{description}</p>
      </div>
    </div>
  )
}
